var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('prism',{staticClass:"rounded shadow",staticStyle:{"height":"321px"},attrs:{"language":"javascript"}},[_vm._v(" "+_vm._s(_vm.code)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }